export default "__VITE_ASSET__DqskXKzA__"